import _findIndex from 'lodash/findIndex';
// Import _sortBy from 'lodash/sortBy';
// import _toLower from 'lodash/toLower';

/**
 * @desc  TagService class.
 * @ngInject
 */
export default class TagService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   * @param {SchoolClassService} SchoolClassService
   */
  constructor(
    $rootScope, $q, $log, $http,
    SchoolClassService
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
    this.SchoolClassService = SchoolClassService;

    this.tags = {};

    this.$rootScope.$on('scr.select', () => {
      if (this.tags.data && this.tags.data.length > 0) {
        this.tags.data.splice(0, this.tags.data.length);
      }
    });
  }

  create(data) {
    return this.$http({
      method: 'POST',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/tags`,
      data
    }).then(result => {
      result.data.map(item => {
        item.studentsNumber = item.students.length;
        this.tags.data.unshift(item);
        return item;
      });
      this.tags.metadata.total = this.tags.data.length;
      return result.data;
    }, err => this.$q.reject(err));
  }

  get(id) {
    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/tags/${id}`
    }).then(result => result.data, err => this.$q.reject(err));
  }

  list(params = {}, fromServer = false) {
    if (angular.isDefined(this.tags.data) && this.tags.data.length > 0 && !fromServer) {
      return this.$q.resolve(this.tags);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/tags`,
      params: {
        limit: params.limit,
        offset: params.offset
      }
    }).then(result => {
      this.tags = result.data;
      return this.tags;
    }, err => this.$q.reject(err));
  }

  update(data) {
    const tag = {};
    angular.copy(data, tag);
    return this.$http({
      method: 'PUT',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/tags/${data.id}`,
      data: {
        name: data.name,
        students: data.students
      }
    }).then(() => {
      const index = _findIndex(this.tags.data, ['id', tag.id]);
      tag.studentsNumber = tag.students.length;
      if (index > -1) {
        this.tags.data[index] = tag;
      }

      return true;
    }, err => this.$q.reject(err));
  }

  destroy(id = 0) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/tags/${id}`
    }).then(result => {
      const idToRemove = _findIndex(this.tags.data, ['id', id]);
      this.tags.data.splice(idToRemove, 1);
      this.tags.metadata.total = this.tags.data.length;
      return result;
    }, err => this.$q.reject(err));
  }
}
